module.exports = __webpack_public_path__ + "static/media/2017_conf_Innovation_Strategies.1178387a.jpg";